import React from "react";
import classNames from "classnames";
import "./EmptyState.scss";

/** Пропсы {@link EmptyState}. */
export interface EmptyStateProps {
    /** Текст или произвольное содержимое сообщения. */
    text: React.ReactNode;
    className?: string;
}

/**
 * Пустое состояние списка или панели выбора.
 */
export function EmptyState({ text, className }: EmptyStateProps) {
    return (
        <div className={classNames("shared_empty_state", className)} role="status">
            {text}
        </div>
    );
}
